import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-3">
            热门话题标签
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            全网最热话题一网打尽，点击标签直达相关爆料
          </p>
        </div>

        <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-3">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-primary-50 transition-all group cursor-pointer"
            >
              <span className="text-sm font-semibold text-foreground-800 font-heading whitespace-nowrap">
                #{item.name}
              </span>
              <span className={`px-2 py-0.5 text-[10px] font-bold rounded-full whitespace-nowrap ${
                item.tag === '爆'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-accent-100 text-accent-700'
              }`}>
                {item.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}